import { Box, TextField } from "@mui/material";
import { useState } from "react";

const SingleMultipleResponse = ({ question, selections, themeColors }) => {
    const [choices, _] = useState(
        typeof selections[question.id] == "string" ? selections[question.id] : Object.values(selections[question.id]),
    );
    return (
        <Box sx={{ mb: 5 }}>
            {choices.map((choice, index) => (
                <TextField
                    key={index}
                    value={choice.label}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    className="mb-2 box-border break-inside-avoid"
                    multiline={true}
                    inputProps={{ style: { cursor: "pointer" } }}
                    sx={{
                        minWidth: { md: 280, lg: 300 },
                        width: "100%",
                    }}
                />
            ))}
        </Box>
    );
};

export default SingleMultipleResponse;
